import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { messageTypes } from '../helpers/MessageTypes';

@Injectable()
export class MessageService {
    private subject = new Subject<any>();

    sendMessage(message: string) {
        this.subject.next({ text: message });
    }

    sendObject(obj: any){
        console.log('object sent', obj)
        this.subject.next(obj);
    }

    clearMessages() {
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/service/message.service.ts